import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import bonusPackagesUrl from '../../../../../assets/images/how-to/bonus-packages.svg';
import buyFittedLensesUrl from '../../../../../assets/images/how-to/buy-fitted-lenses.svg';
import { HowTo } from '../../../../common/how-to';
import { Button } from '../../../../common/button';
import { IHowToCard } from '../../../../common/how-to/how-to-card';

export const HowToSpendPoints = (): JSX.Element => {
  const intl = useIntl();

  const discounts: IHowToCard = {
    imageSource: bonusPackagesUrl,
    description: intl.formatMessage(
      { id: 'pointsHowTo.spendPoints.bonusPackages.description' },
      {
        sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
        nonBreakSpace: <>&nbsp;</>,
      },
    ),
  };

  const barcode: IHowToCard = {
    imageSource: buyFittedLensesUrl,
    description: <FormattedMessage id="pointsHowTo.spendPoints.spendByBarcode.description" />,
  };

  const howToItems: IHowToCard[] = [discounts, barcode];

  return (
    <HowTo
      title={<FormattedMessage id="pointsHowTo.spendPoints.title" />}
      items={howToItems}
      footer={(
        <Button
          variant="contained"
          href={intl.formatMessage({ id: 'common.phoneNumber.support.href' })}
        >
          <FormattedMessage id="common.phoneNumber.support" />
        </Button>
      )}
    />
  );
};
